import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import GradientWrapper from '../GradientBox/GradientWrapper';
import { parseStats } from '../globalUtils';
const StatsGrid = ({ columns, rows, allowOpen, className, }) => {
    const setup = useRef({
        columns: columns.split(','),
        rows: parseStats(columns, rows),
    });
    return (_jsxs("div", { className: `stats-container${className ? ` ${className}` : ''}${setup.current.rows.length > 3 ? ' small-font' : ''}`, children: [setup.current.rows.map((row, rowIndex) => (_jsx("div", { className: "stats-row", children: row.map((cell, colIndex) => (_jsx("div", { className: "stats-cell", style: {
                        flex: Number(setup.current.columns[colIndex]) || 1,
                    }, children: cell.split('\n').map((line, i) => (_jsx("div", { children: line }, i))) }, colIndex))) }, rowIndex))), _jsx(GradientWrapper, { active: allowOpen })] }));
};
export default StatsGrid;
